module.exports = {
	accepted: 'The :attribute must be accepted.',
	alpha: 'The :attribute field must contain only alphabetic characters.',
	alpha_dash: 'The :attribute field may only contain alpha-numeric characters, as well as dashes and underscores.',
	alpha_num: 'The :attribute field must be alphanumeric.',
	between: 'The :attribute field must be between :min and :max.',
	confirmed: 'The :attribute confirmation does not match.',
	email: 'The :attribute format is invalid.',
	def: 'The :attribute attribute has errors.',
	digits: 'The :attribute must be :digits digits.',
	different: 'The :attribute and :different must be different.',
	'in': 'The selected :attribute is invalid.',
	integer: 'The :attribute must be an integer.',
	min: {
		numeric: 'The :attribute must be at least :min.',
		string: 'The :attribute must be at least :min characters.'
	},
	max: {
		numeric: 'The :attribute must be less than :max.',
		string: 'The :attribute must be less than :max characters.'
	},
	not_in: 'The selected :attribute is invalid.',
	numeric: 'The :attribute must be a number.',
	required: 'The :attribute field is required.',
	required_if: 'The :attribute field is required when :other is :value.',
	same: 'The :attribute and :same fields must match.',
	size: {
		numeric: 'The :attribute must be :size.',
		string: 'The :attribute must be :size characters.'
	},
	url: 'The :attribute format is invalid.',
	regex: 'The :attribute format is invalid',
	attributes: {}
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/validatorjs/src/lang/en.js
 ** module id = 82
 ** module chunks = 0
 **/